/**
 * An enumeration that divides the connection experience
 */
export enum ConnectionQuality {
    DoesNotMeetMinimumRequirements = 1,
    DoesNotMeetRecomendedRequirements = 2,
    ExceedsRecommendedRequirements = 3
}
